<style>
html {
  overflow: hidden;
}
</style>

<template>
  <div id="app">
    <v-app>
      <v-content>
        <router-view/>
      </v-content>
    </v-app>
  </div>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/App.vue